import { getCloudEnvironmentResolver } from "../resolution/getCloudEnvironmentResolver";
import type { CloudEnvironment } from "../types/CloudEnvironment";

export async function getCloudEnvironmentForEmailAddress(emailAddress: string): Promise<CloudEnvironment> {
    const resolver = await getCloudEnvironmentResolver();
    return resolver.resolveConfigForEmailAddress(emailAddress);
}
